// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","W-0":"#FFF","NG-50":"#F4F7FA","CG-200":"#AEB7C0","S-400":"#615CFF","tabs":"Ga06999","tab":"G155757 G982276","tabActive":"Ga7f3e3"};